module.exports = __webpack_public_path__ + "static/fonts/roboto-regular.665b409.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/roboto-regular.woff2
// module id = 4RHE
// module chunks = 1